export default [
  {
    path: 'id-types',
    name: 'id-types',
    meta: {
      requiredPrivileges: ['System Settings']
    },
    component: () =>
      import('@/modules/global-settings/miscellaneous/views/IdTypes.vue')
  },
  {
    path: 'custom-templates',
    name: 'custom-templates',
    meta: {
      requiredPrivileges: ['System Settings']
    },
    component: () =>
      import('@/modules/shared/components/template-builder/TemplatesPage.vue')
  },
  {
    path: 'notification-logs',
    name: 'settings-notification-logs',
    meta: {
      requiredPrivileges: ['System Settings']
    },
    component: () => import('@/modules/shared/views/NotificationLogs.vue')
  },
  {
    path: 'reference-types',
    name: 'settings-reference-types',
    meta: {
      requiredPrivileges: ['System Settings']
    },
    component: () =>
      import('@/modules/global-settings/miscellaneous/views/Reference.vue')
  },
  {
    path: 'source-of-wealth',
    name: 'settings-source-of-wealth',
    meta: {
      requiredPrivileges: ['System Settings']
    },
    component: () =>
      import('@/modules/global-settings/miscellaneous/views/SourceOfWealth.vue')
  },
  {
    path: 'source-of-income',
    name: 'settings-source-of-income',
    meta: {
      requiredPrivileges: ['System Settings']
    },
    component: () =>
      import('@/modules/global-settings/miscellaneous/views/SourceOfIncome.vue')
  },
  {
    path: 'relations-settings',
    name: 'settings-relations-settings',
    meta: {
      requiredPrivileges: ["System Settings"]
    },
    component: () =>
      import('@/modules/global-settings/miscellaneous/views/RelationSettings.vue')
  },
  {
    path: 'age-classification',
    name: 'settings-age-classification',
    meta: {
      requiredPrivileges: ['System Settings']
    },
    component: () =>
      import(
        '@/modules/global-settings/miscellaneous/views/AgeClassification.vue'
      )
  }  
];
